/**
 * This mixin is used to get Gift Cards balance.
 */
export default {
  context: ['currentUser'],
  models: {
    giftCards: {
      variables () {
        return {
          userId: this.currentUser?.id,
          limit: 100,
          skip: !this.currentUser
        }
      }
    }
  },
  computed: {

    activeGiftCards () {
      if (!this.giftCards) {
        return []
      }
      return _.filter(this.giftCards.data, giftCard => giftCard.state === 'valid' && giftCard.balance > 0)
    },
    expiredUsedGiftCards () {
      if (!this.giftCards) {
        return []
      }
      return _.filter(this.giftCards.data, giftCard => giftCard.state !== 'valid' || giftCard.balance === 0)
    },
    totalGiftCardBalance () {
      if (!this.activeGiftCards || this.activeGiftCards.length === 0) {
        return 0
      }
      return _.sumBy(this.activeGiftCards, 'balance')
    }
  }
}
